module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 5